import { videoUrl } from "@/mocks/home";

export default function VideoSection() {
  return (
    <section id="video" className="w-full px-4 md:px-12 py-8 flex justify-center">
      <div className="relative w-full max-w-md mx-auto aspect-[9/16] rounded-3xl overflow-hidden shadow-2xl bg-stone-950">
        <video
          className="w-full h-full object-contain"
          src={videoUrl}
          autoPlay
          muted
          loop
          playsInline
          aria-label="Vídeo de apresentação do Jack's House Rock Bar"
        />
      </div>
    </section>
  );
}